import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import VueVideoPlayer from 'vue-video-player/src'
import vOutsideEvents from 'vue-outside-events';
import RichWarpText from '@/components/richWarpText.vue'
import DisableDevtool from 'disable-devtool';
import MapAnd360 from '@/components/mapAnd360'
import ImagePreviewPro from '@/components/image-viewer.vue'
 
// require videojs style
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'

import 'element-ui/lib/theme-chalk/index.css';
import "swiper/css/swiper.css";
import '@/styles/index.scss' // global css
import 'animate.css';
 // icon
import './icons'

import Vuex from 'vuex'

import router from './router'

import store from './store'


Vue.config.productionTip = false

// if (process.env.NODE_ENV !== 'development') {
//   DisableDevtool()
// }

Vue.component('RichWarpText', RichWarpText)
Vue.component('MapAnd360', MapAnd360)
Vue.component('ImagePreviewPro', ImagePreviewPro)

Vue.use(ElementUI);

Vue.use(Vuex)

Vue.use(VueVideoPlayer)

Vue.use(vOutsideEvents)


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
